import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function TomosSection() {
  const tomos = [{
    id: 1,
    title: 'Las Bases del Aprendizaje Visual',
    fichas: 'Fichas #0 a #25',
    desc: 'El punto de partida real. Antes de la letra, el cuerpo. Antes del lápiz, la mano. Antes de la ficha, la rutina.',
    bullets: ['Fichas de trazo libre y control motor básico', 'Reconocimiento de las 5 vocales con pictogramas consistentes', 'Direccionalidad de izquierda a derecha', 'El nombre propio como primera palabra funcional', 'Primeras sílabas MA y PA', 'Tabla de seguimiento para registrar cada avance']
  }, {
    id: 2,
    title: 'Conciencia Fonológica',
    fichas: 'Fichas #26 a #50',
    desc: 'Del sonido a la letra. Sin saltearse pasos.',
    bullets: ['Palmadas por sílaba para anclar el sonido en el cuerpo', 'Separación visual de palabras bisílabas y trisílabas', 'Identificación del sonido inicial de cada palabra', 'Rimas simples y conteo de palabras en oraciones', 'Dictado silábico y primer dictado de palabras completas', 'Tarjetas SÍ y NO para respuesta no verbal']
  }, {
    id: 3,
    title: 'El Código Visual: Vocabulario Funcional',
    fichas: 'Fichas #51 a #75',
    desc: 'Las palabras que no pueden esperar. BAÑO. SALIDA. ESPERA. PELIGRO. AYUDA.',
    bullets: ['Palabras de rutina para la agenda visual diaria', 'El nombre propio en todos los contextos de la vida del niño', 'El Muro de Palabras personal del niño', 'Comprensión de instrucciones escritas simples', 'Buscador de palabras y oración con vocabulario funcional']
  }, {
    id: 4,
    title: 'Trazo y Grafomotricidad Sensorial',
    fichas: 'Fichas #76 a #100',
    desc: 'Para el niño que no agarra el lápiz. Para el niño que lo rompe. Para el niño que necesita que su cuerpo esté listo antes de escribir.',
    bullets: ['Checklist sensorial antes de cada sesión', 'Actividades sensoriales previas al papel (bandeja de arena, plastilina, crema)', 'Progresión desde el garabato hasta la letra dentro del renglón', 'Grupo palitos: I, L, T, E', 'Grupo curvos: C, O, U', 'Grupo mixtos: P, B, D', 'Ficha específica de discriminación B y D para prevenir inversiones']
  }, {
    id: 5,
    title: 'Lectura Comprensiva Funcional',
    fichas: 'Fichas #101 a #125',
    desc: 'Leer no es pronunciar letras. Leer es entender.',
    bullets: ['De la oración de 3 palabras al texto de 3 oraciones', 'Verdadero y falso, identificación de sujeto y verbo', 'Instrucciones escritas de 1 y 2 pasos', 'Conectores Y y DESPUÉS en textos reales', 'Preguntas ¿Qué? ¿Quién? ¿Dónde? sobre textos funcionales', 'Inferencias simples con banco de palabras de apoyo', 'Primer texto completado por el propio niño']
  }, {
    id: 6,
    title: 'Escritura y Autonomía Comunicativa',
    fichas: 'Fichas #126 a #150',
    desc: 'De las letras a las palabras. De las palabras al mundo.',
    bullets: ['Etiquetas personales para sus objetos', 'Lista de compras y lista de cosas que le gustan', 'Notas para mamá y para la maestra', 'El diario de comunicación casa-escuela', 'Estructuras YO SOY / YO TENGO / YO QUIERO / YO NO QUIERO', 'Su historia personal en 2 o 3 oraciones propias', 'Su libro personal: portada y primera página']
  }];
  return <section className="py-20 px-4 bg-gray-50" data-id="element-246">
      <div className="max-w-5xl mx-auto" data-id="element-247">
        <div className="text-center mb-16" data-id="element-248">
          <h2 className="text-4xl md:text-5xl font-black text-[#111111] mb-4" data-id="element-249">
            QUÉ TE LLEVÁS HOY
          </h2>
          <div className="w-24 h-1.5 bg-[#C4A7E7] mx-auto rounded-full" data-id="element-250"></div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-[#C4A7E7] text-[#111111] rounded-3xl p-8 md:p-12 mb-16 shadow-2xl relative overflow-hidden" data-id="element-251">
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4" data-id="element-252"></div>
          <div className="relative z-10" data-id="element-253">
            <h3 className="text-2xl md:text-3xl font-bold mb-4 text-[#111111]" data-id="element-254">
              EL PUENTE VISUAL UNIFICADO — El corazón del sistema
            </h3>
            <p className="text-lg md:text-xl mb-6 font-medium" data-id="element-255">
              El error más común en la alfabetización de niños con autismo es
              cambiarles el código todo el tiempo.
            </p>
            <p className="text-lg mb-6 text-[#111111]/80" data-id="element-256">
              El <strong data-id="element-257">Puente Visual Unificado</strong> es el mecanismo que
              hace que este kit sea diferente a todo lo que existe: el mismo
              pictograma que el niño usa en la primera ficha del Tomo 1 es el
              que está pegado en la heladera de su casa y en el banco de su
              escuela.
            </p>
            <p className="text-xl font-bold bg-white/30 inline-block px-6 py-3 rounded-xl" data-id="element-258">
              Un solo código. En todos los contextos. Para siempre.
            </p>
            <p className="mt-6 text-lg text-[#111111]/80 italic" data-id="element-259">
              Eso no es un detalle. Es la razón por la que este sistema funciona
              cuando los otros no funcionan.
            </p>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16" data-id="element-260">
          {tomos.map((tomo, idx) => <motion.div key={tomo.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white border border-gray-100 rounded-3xl p-8 shadow-sm flex flex-col h-full" data-id="element-261">
              <div className="flex items-start gap-4 mb-6" data-id="element-262">
                <span className="text-4xl" data-id="element-263">📘</span>
                <div data-id="element-264">
                  <h4 className="text-xl font-bold text-[#C4A7E7] leading-tight" data-id="element-265">
                    TOMO {tomo.id} — {tomo.title}
                  </h4>
                  <span className="inline-block bg-gray-100 text-[#C4A7E7] font-bold text-sm px-3 py-1 rounded-full mt-2" data-id="element-266">
                    {tomo.fichas}
                  </span>
                </div>
              </div>

              <p className="text-[#111111] font-medium mb-6 italic" data-id="element-267">
                {tomo.desc}
              </p>

              <ul className="space-y-3 mt-auto" data-id="element-268">
                {tomo.bullets.map((bullet, bIdx) => <li key={bIdx} className="flex items-start gap-3" data-id="element-269">
                    <CheckIcon className="w-5 h-5 text-[#C4A7E7] flex-shrink-0 mt-0.5" data-id="element-270" />
                    <span className="text-gray-700 text-sm md:text-base" data-id="element-271">
                      {bullet}
                    </span>
                  </li>)}
              </ul>
            </motion.div>)}
        </div>
      </div>
    </section>;
}